var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFallingBack && _vm.fallbackIcon)?_c('Icon',{attrs:{"name":_vm.fallbackIcon}}):_c('img',{ref:"image",attrs:{"src":_vm.isFallingBack ? _vm.fallback : _vm.image},on:{"load":_vm.onLoad,"error":_vm.useFallback}})}
var staticRenderFns = []

export { render, staticRenderFns }